import { useTranslation } from 'react-i18next';

import IconDeniedSolid from '~icons/teenyicons/denied-solid';

import { EmptySection } from './EmptySection';

interface NoPermissionsPageProps {
	message?: string;
}

export function NoPermissionsPage({ message }: NoPermissionsPageProps) {
	const { t } = useTranslation('permissions');
	return (
		<EmptySection
			Icon={IconDeniedSolid}
			message={message || t('no permission page')}
			missingPermission
		/>
	);
}
